// extracted by mini-css-extract-plugin
module.exports = {"productDescription":"styles_productDescription__31nCj"};